import { IPetItemResponse } from "../../services/pet-list/pet-list.interface";
import {
  ILocationItemResponse,
} from "../../services/edit-hospital-location/edit-hospital-location.interface";

export interface SelectedSlot {
  time: string;
  resourcesId: string;
  label: string;
}

export interface PetBookingData {
  selectedReasons: string[];
  additionalNotes: string;
}

export interface UrgentVisitBookingResponse {
  start_at: number;
  end_at: number;
  duration: number;
  appointmentCreateType: number;
  promoCode: string[] | null;
  resources: { id: Number; name: string }[];
  pets: {
    id: string;
    name: string;
    image: string;
    speciesName: string;
    breedName: string;
    reasonForVisit: string;
  }[];
  location: {
    idLocation: string;
    locationName: string;
    address: string;
    city: string;
    position: { lat: number; lng: number };
    email: string;
    phoneNumber: string;
    timeZone: string;
  };
  success: boolean;
  messages: string[];
}

/* eslint-disable no-unused-vars */
export enum UrgentVisitStep {
  PET_SELECTION = "PET_SELECTION",
  TIME_SELECTION = "TIME_SELECTION",
  REASON_SELECTION = "REASON_SELECTION",
  ADDITIONAL_NOTES = "ADDITIONAL_NOTES",
  REVIEW = "REVIEW",
  BOOKED = "BOOKED",
}

export const actionTypes = {
  UV_SET_STEP: "UV_SET_STEP",
  UV_SET_SELECTED_PETS: "UV_SET_SELECTED_PETS",
  UV_SET_SELECTED_SLOT: "UV_SET_SELECTED_SLOT",
  UV_SET_SELECTED_LOCATION: "UV_SET_SELECTED_LOCATION",
  UV_SET_HOME_LOCATION_ID: "UV_SET_HOME_LOCATION_ID",
  UV_SET_PET_REASONS: "UV_SET_PET_REASONS",
  UV_SET_PET_NOTES: "UV_SET_PET_NOTES",
  UV_SET_CURRENT_PET_INDEX: "UV_SET_CURRENT_PET_INDEX",
  UV_SET_BOOKING_RESPONSE: "UV_SET_BOOKING_RESPONSE",
  UV_SET_PROMO_CODES: "UV_SET_PROMO_CODES",
  UV_SET_TIMEZONE: "UV_SET_TIMEZONE",
  UV_SET_SLOT_UNAVAILABLE_MESSAGE: "UV_SET_SLOT_UNAVAILABLE_MESSAGE",
  UV_SET_IS_MULTI_PET_OWNER: "UV_SET_IS_MULTI_PET_OWNER",
  UV_SET_SELECTED_DATE: "UV_SET_SELECTED_DATE",
  UV_SET_RESCHEDULE_APPOINTMENT_ID: "UV_SET_RESCHEDULE_APPOINTMENT_ID",
  UV_SET_PET_APPOINTMENT_MAP: "UV_SET_PET_APPOINTMENT_MAP",
  UV_RESET: "UV_RESET",
};

const setStep = (payload: UrgentVisitStep) => ({
  type: actionTypes.UV_SET_STEP, payload,
});

const setSelectedPets = (payload: IPetItemResponse[]) => ({
  type: actionTypes.UV_SET_SELECTED_PETS, payload,
});

const setSelectedSlot = (payload: SelectedSlot | null) => ({
  type: actionTypes.UV_SET_SELECTED_SLOT, payload,
});

const setSelectedLocation = (payload: {
  locationId: string;
  locationDetails: ILocationItemResponse;
}) => ({
  type: actionTypes.UV_SET_SELECTED_LOCATION, payload,
});

const setHomeLocationId = (payload: string) => ({
  type: actionTypes.UV_SET_HOME_LOCATION_ID, payload,
});

const setPetReasons = (payload: {
  petId: string; reasons: string[];
}) => ({
  type: actionTypes.UV_SET_PET_REASONS, payload,
});

const setPetNotes = (payload: {
  petId: string; notes: string;
}) => ({
  type: actionTypes.UV_SET_PET_NOTES, payload,
});

const setCurrentPetIndex = (payload: number) => ({
  type: actionTypes.UV_SET_CURRENT_PET_INDEX, payload,
});

const setBookingResponse = (
  payload: UrgentVisitBookingResponse,
) => ({
  type: actionTypes.UV_SET_BOOKING_RESPONSE, payload,
});

const setPromoCodes = (payload: string[]) => ({
  type: actionTypes.UV_SET_PROMO_CODES, payload,
});

const setTimezone = (payload: string) => ({
  type: actionTypes.UV_SET_TIMEZONE, payload,
});

const setSlotUnavailableMessage = (payload: string) => ({
  type: actionTypes.UV_SET_SLOT_UNAVAILABLE_MESSAGE, payload,
});

const setIsMultiPetOwner = (payload: boolean) => ({
  type: actionTypes.UV_SET_IS_MULTI_PET_OWNER, payload,
});

const setSelectedDate = (payload: number) => ({
  type: actionTypes.UV_SET_SELECTED_DATE, payload,
});

const setRescheduleAppointmentId = (payload: string | null) => ({
  type: actionTypes.UV_SET_RESCHEDULE_APPOINTMENT_ID, payload,
});

const setPetAppointmentMap = (payload: Record<string, string>) => ({
  type: actionTypes.UV_SET_PET_APPOINTMENT_MAP, payload,
});

const reset = () => ({
  type: actionTypes.UV_RESET,
});

export default {
  setStep,
  setSelectedPets,
  setSelectedSlot,
  setSelectedLocation,
  setHomeLocationId,
  setPetReasons,
  setPetNotes,
  setCurrentPetIndex,
  setBookingResponse,
  setPromoCodes,
  setTimezone,
  setSlotUnavailableMessage,
  setIsMultiPetOwner,
  setSelectedDate,
  setRescheduleAppointmentId,
  setPetAppointmentMap,
  reset,
};
